import axios from 'axios';

declare global {
  interface Window {
    __API_URL__: string;
    __APP_DOMAIN__: string;
    __API_DOMAIN__: string;
    __PORTAL_URL__: string;
    __FS_URL__: string;
    __WS_URL__: string;
    __IMG_STORE__: string;
    __STATIC_URL__: string;
  }
}

/**
 * Axios-инстанс для API.
 * Auth-interceptors подключаются в AuthStore.
 *
 * baseURL берётся из env.js (window.__API_URL__),
 * который генерируется start.sh при деплое.
 */
export const apiClient = axios.create({
  baseURL: window.__API_URL__ || 'https://api.dev.resonline.ru',
  withCredentials: false,
});

/**
 * Адрес эндпоинта API v1.
 *
 * `envUrls.api` — это только хост (`https://api.dev.resonline.ru`),
 * без префикса версии. Его нужно дописывать: правильный вызов
 * выглядит как `${envUrls.api}/api/v1/housekeeping/dashboard`.
 *
 * Забыть `/api/v1` легко, а последствие неочевидное: запрос уходит
 * на живой хост, Django отвечает 404, и экран показывает «не
 * удалось загрузить» — будто сломался бэкенд. Именно так я потерял
 * время на экране «Сегодня» 28.10.2026. Эта функция существует,
 * чтобы префикс нельзя было пропустить.
 *
 *     apiV1('/ops/today')  →  https://api.dev.resonline.ru/api/v1/ops/today
 */
export function apiV1(path: string): string {
  const tail = path.startsWith('/') ? path : `/${path}`;
  return `${envUrls.api}/api/v1${tail}`;
}

/**
 * Хелперы для получения URL'ов из env.js
 */
export const envUrls = {
  get api() {
    return window.__API_URL__ || 'https://api.dev.resonline.ru';
  },
  get portal() {
    return window.__PORTAL_URL__ || 'https://portal.dev.resonline.ru';
  },
  get images() {
    return window.__IMG_STORE__ || 'https://images.dev.resonline.ru';
  },
  get ws() {
    return window.__WS_URL__ || 'wss://api.dev.resonline.ru/ws';
  },
  get static() {
    return window.__STATIC_URL__ || 'https://static.dev.resonline.ru';
  },
};
